export default "__VITE_ASSET__DqY930aF__"